import { Document as docxDocument, Packer, Paragraph, TextRun } from "docx";
import { uploadFileToDrive } from "./uploadFilesToDrive";



export const convertToDocx = (data, upload=true,profileName,gapi,authenticate,saveAs) => {
  let counter = 0;

  console.log("UPLOAD VALUE",upload)

  const parseHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp;
  };

  function containsMarkdown(text) {
    const markdownPatterns = [
      [/(\*\*|__)(.*?)\1/g, "$2"], // Bold (keep content)
      [/(\*|_)(.*?)\1/g, "$2"], // Italic (keep content)
      [/(\s|^)(#{1,6}\s)/g, ""], // Headers
      [/\[(.*?)\]\((.*?)\)/g, "$1"], // Links (keep the text only)
    ];

    function processLine(line) {
      markdownPatterns.forEach(([pattern, replacement]) => {
        line = line.replace(pattern, replacement);
      });
      return line;
    }

    return text.split(/\r?\n/).map(processLine).join("\n");
  }


  const processMessage = (entry) => {
    const tmp = parseHtml(entry.message);
    const paragraphs = [];

    tmp.childNodes.forEach((node) => {
      if (node.nodeName === "P") {
        const paragraphLines = node.textContent.split('\n');
        paragraphLines.forEach(line => {
          const trimmedLine = line.trim();
          if (trimmedLine) {
            // Convert hyphens to bullets and clean markdown
            const processedLine = containsMarkdown(
              trimmedLine.startsWith("- ") ? 
              `• ${trimmedLine.substring(2)}` : 
              trimmedLine
            );
            paragraphs.push(processedLine);
          } 
        });
      } else if (node.nodeName === "UL") {
        paragraphs.push(""); // Blank line before bullet group
        node.querySelectorAll("li").forEach((li) => {
          const indent = li.classList.contains("ql-indent-1") ? "  " : "";
          const text = containsMarkdown(li.textContent.trim());
          paragraphs.push(`${indent}• ${text}`);
        });
      } else if (node.nodeName === "OL") {
        let i = 1;
        node.querySelectorAll("li").forEach((li) => {
          const indent = li.classList.contains("ql-indent-1") ? "  " : "";
          const text = containsMarkdown(li.textContent.trim());
          paragraphs.push(`${indent}${i}. ${text}`);
          i++;
        });
      } else {
        const textLines = node.textContent.split('\n');
        textLines.forEach(line => {
          const trimmedLine = line.trim();
          if (trimmedLine) {
            // Convert hyphens to bullets and clean markdown
            const processedLine = containsMarkdown(
              trimmedLine.startsWith("- ") ? 
              `• ${trimmedLine.substring(2)}` : 
              trimmedLine
            );
            paragraphs.push(processedLine);
          } 
        });
      }
    });

    let textBlock = paragraphs.join("\n");
    textBlock = textBlock.replace(/(?<!\n)\n?(\d+\.\s)/g, "\n$1"); // Fix numbered lists

    if (entry.user === "user") {
      counter++;
      return `${counter}) ${textBlock}`;
    }
    return textBlock;
  };

  const doc = new docxDocument({
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 720,
              right: 720,
              bottom: 720,
              left: 720,
            },
          },
        },
        children: data.flatMap((entry) => {
          const content = processMessage(entry);
          const lines = content.split('\n');
          const docxParagraphs = [];

          lines.forEach((line, index) => {
            const trimmedLine = line.trim();
            const isBullet = trimmedLine.startsWith("•") || trimmedLine.startsWith("-");
            const isNumbered = /^\d+\./.test(trimmedLine);
            
            if (trimmedLine === "") {
              // Empty line - create paragraph break
              docxParagraphs.push(
                new Paragraph({
                  children: [new TextRun("")],
                  spacing: { after: 60 },
                })
              );
            } else if (isBullet || isNumbered) {
              // Convert hyphens to bullets if needed
              const displayText = trimmedLine.startsWith("- ") ? 
                `• ${trimmedLine.substring(2)}` : 
                trimmedLine;
              
              // Add space before list if needed
              if (index > 0 && !lines[index-1].trim().match(/^(•|\d+\.)/)) {
                docxParagraphs.push(
                  new Paragraph({
                    children: [new TextRun("")],
                    spacing: { after: 60 },
                  })
                );
              }
              
              // Create list item with proper indentation
              const indent = line.startsWith("  ") ? { left: 100 } : undefined;
              docxParagraphs.push(
                new Paragraph({
                  indent,
                  children: [new TextRun({
                    text: containsMarkdown(displayText)
                  })],
                  spacing: { after: isBullet ? 100 : 120 },
                })
              );
              
              // Add space after last list item if needed
              if (index < lines.length-1 && !lines[index+1].trim().match(/^(•|\d+\.)/)) {
                docxParagraphs.push(
                  new Paragraph({
                    children: [new TextRun("")],
                    spacing: { after: 60 },
                  })
                );
              }
            } else {
              // Regular text
              docxParagraphs.push(
                new Paragraph({
                  children: [new TextRun(containsMarkdown(line))],
                  spacing: { after: 200 },
                })
              );
            }
          });

          return docxParagraphs;
        }),
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    if (upload) {
      authenticate().then(() => uploadFileToDrive(blob,profileName,gapi));
    } else {
      saveAs(blob, `${profileName}.docx`);
    }
  });
};